import { render } from "./AcquisitonProductSearch.vue?vue&type=template&id=1d531f14&scoped=true"
import script from "./AcquisitonProductSearch.vue?vue&type=script&lang=js"
export * from "./AcquisitonProductSearch.vue?vue&type=script&lang=js"

import "./AcquisitonProductSearch.vue?vue&type=style&index=0&id=1d531f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d531f14"]])

export default __exports__